import { useQueryClient } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { HouseConsignment } from '../models/types'
import { deleteHouseConsignmentV2 } from '../api/http'

function useDeleteHouseConsignment(consignmentId: number) {
  const queryClient = useQueryClient()

  const deleteHouseConsignment = async (houseConsignmentId: number): Promise<void> => {
    await deleteHouseConsignmentV2(houseConsignmentId)
    if (!houseConsignmentId) throw new Error('Missing house consignment ID')

    queryClient.setQueryData<HouseConsignment[]>(QueryKeys.houseConsignment.all(consignmentId), (prev) => (prev
      ? prev.filter((house) => house.id !== houseConsignmentId) : prev))

    await queryClient.invalidateQueries(QueryKeys.consignment.summary(consignmentId))
  }

  return {
    deleteHouseConsignment,
  }
}

export default useDeleteHouseConsignment
